import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { CurrenciesFilterDataDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { createAsyncFilterWithQuery } from './createAsyncFilterWithQuery'

export const createCurrencyAsyncFilter = (
  apolloClient: ApolloClient<unknown>,
  companyId: number
): FilterDefinition =>
  createAsyncFilterWithQuery({
    label: i18n.t('expenses_v2.list.header.currency'),
    apolloClient,
    query: CurrenciesFilterDataDocument,
    variables: {},
    mapData: (data) => {
      const currencies = data?.apiCore?.currencies || []
      return currencies.map((currency) => ({
        label: `${currency.isoCode} - ${currency.name}`,
        value: currency.isoCode,
      }))
    },
  })
